import { AxiosResponse } from 'axios';
import { api } from '../../providers/base-api';
import { GetServicesResponse } from '../../utils/types/data/services/services';

export async function getServicesRequest(): Promise<
  AxiosResponse<GetServicesResponse>
> {
  const response = await api.get<GetServicesResponse>('services');

  return response;
}
